import { ActionTypes } from "../constants";

const reduceFacilitators = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_MSF_FACILITATORS_SUCCESS:
            return action.data || [];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceFacilitators;
